var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 29,
    viewBox: "0 0 38 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2948 14.9915C29.2978 15.0133 30.3065 14.9472 31.3054 15.0259C32.3171 15.2146 32.5609 16.7461 31.6621 17.2477C31.0489 17.5782 30.3204 17.3708 29.6555 17.4291H28.2948V14.9915ZM31.8854 12.2325C32.1082 13.0191 31.35 13.7253 30.5924 13.617H28.2948C28.3109 12.8752 28.2633 12.0702 28.3181 11.3675C29.2386 11.3934 30.1675 11.3146 31.0826 11.4087C31.4758 11.5075 31.8049 11.8307 31.8854 12.2325ZM37.4149 0.568353C37.4576 2.07045 37.4211 3.65194 37.4333 5.18451C37.4305 11.4154 37.4394 17.6461 37.4285 23.8773C37.3881 26.2124 35.3186 28.2415 32.9996 28.2881C30.6784 28.2976 28.3568 28.2896 26.0352 28.2921V18.8724C28.5646 18.8593 31.0954 18.8989 33.6238 18.8526C34.7968 18.779 36.0815 18.0051 36.1361 16.7143C36.2742 15.4179 35.052 14.5213 33.8916 14.3797C33.4456 14.3681 33.4586 14.2496 33.8916 14.198C34.9984 13.9587 35.8675 12.8133 35.5419 11.6661C35.2644 10.4595 33.9308 9.99249 32.8215 9.99481C30.5597 9.97945 28.2976 9.99266 26.0357 9.9882C26.0503 8.22964 26.0052 6.4692 26.06 4.71193C26.2392 2.41892 28.3608 0.527927 30.6472 0.568954C32.9034 0.56861 35.1592 0.56861 37.4149 0.568525V0.568353Z",
    fill: "url(#paint0_linear_5_83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.47575 4.94948C0.533513 2.61802 2.61187 0.605578 4.92788 0.571504C7.24055 0.56438 9.55356 0.570474 11.8662 0.568415C11.8599 8.36901 11.8788 16.1705 11.8567 23.9706C11.7676 26.2738 9.71192 28.2478 7.42114 28.2886C5.10409 28.297 2.78679 28.2898 0.469656 28.2921V18.5548C2.72036 19.0865 5.08057 19.3128 7.37668 18.9602C8.74917 18.7393 10.2508 18.0653 10.7155 16.6414C11.0575 15.4234 10.8649 14.1415 10.9158 12.8914V9.98826H6.94221C6.92436 11.9083 6.97877 13.8318 6.91346 15.7495C6.80634 16.9283 5.63898 17.6773 4.52723 17.6373C3.14847 17.6519 0.416269 16.6381 0.416269 16.6381C0.409403 13.0406 0.456266 8.53534 0.47575 4.94983V4.94948Z",
    fill: "url(#paint1_linear_5_83)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3481 11.1593C13.1389 11.2036 13.306 10.4468 13.2526 10.1597C13.2668 8.34441 13.2228 6.52715 13.2769 4.71315C13.4556 2.41044 15.5935 0.514726 17.8891 0.568627H24.6497C24.6433 8.36922 24.6621 16.1707 24.6401 23.9708C24.551 26.274 22.4951 28.248 20.2043 28.2888C17.8871 28.2976 15.5698 28.2902 13.2525 28.2924V17.6238C14.8351 18.9224 16.986 19.1245 18.9577 19.128C20.4441 19.1275 21.9218 18.8983 23.3652 18.5555V16.601C21.7385 17.4118 19.8263 17.9267 18.023 17.4609C16.7651 17.1478 15.852 15.9321 15.8723 14.634C15.7266 13.284 16.5179 11.8587 17.8446 11.4574C19.4917 10.9417 21.2869 11.3361 22.8309 12.0065C23.1617 12.1797 23.4974 12.3945 23.3652 11.8416V10.3054C20.7829 9.69099 18.0349 9.46491 15.4406 10.1333C14.6897 10.3451 13.9581 10.6664 13.3481 11.1594V11.1593Z",
    fill: "url(#paint2_linear_5_83)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_83",
    x1: 25.9574,
    y1: 13.8375,
    x2: 37.3615,
    y2: 13.8375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_83",
    x1: 0.227179,
    y1: 14.6958,
    x2: 11.6794,
    y2: 14.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_83",
    x1: 13.2358,
    y1: 14.1063,
    x2: 24.6475,
    y2: 14.1063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.0a75087c753975ac0c13e024e873850e.svg";
export { ForwardRef as ReactComponent };